/* ============
 * Add producer Component
 * ============
 *
 * This is the component for creating producer
 */
import Forms from '../../utils/forms/forms';
import producerService from '../../services/producer';
import producerTransformer from '../../transformers/producer';
import clientTypeService from './../../services/clientType';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: new Forms({
        typeId: {
          value: '',
          type: 'select',
        },
        name: {
          value: '',
          type: 'text',
        },
      }),
      loading: false,
    };
  },
  created() {
    this.loading = true;
    Promise.all([clientTypeService.all()]).then(() => {
      this.loading = false;
    }).catch(() => {
      this.loading = true;
    });
  },
  computed: {
    ...mapGetters({
      types: 'allClientTypes',
    }),
  },

  methods: {
    /**
     * This method will be called when saving the form.
     */
    save() {
      this.form.loading = true;
      const producer = producerTransformer.send(this.form.data());
      producerService
        .store(producer)
        .then(() => {
          producerService.all();
          this.$emit('close');
        })
        .catch((errors) => {
          this.form.loading = false;
          this.form.recordErrors(errors);
        });
    },
  },
  watch: {
    types(types) {
      if (types) {
        this.form.setOptions(
          'typeId',
          types.map(type => ({
            id: +type.id,
            name: type.name,
          }))
        );
        this.form.typeId = 2; // set 2 = company by default
      }
    },
  },

  components: {
    VForm: require('./../form/form.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/addProducer/addProducer.js